import classNames from "classnames";

import { ArticleExcerpt } from "custom-types/Wordpress";

import ArticleCard from "components/botanic/ArticleCard";
import Carousel from "components/botanic/Carousel";

type Props = {
  articles: ArticleExcerpt[];
  articleCardOnClick?: (index: number, articleTitle: string) => void;
  className?: string;
  title: string;
  seeMoreHref?: string;
  seeMoreText?: string;
  seeMoreOnClick?: () => void;
};

const ArticlesCarousel = ({
  articles,
  articleCardOnClick = () => {},
  className,
  title,
  seeMoreHref,
  seeMoreText = "Show all",
  seeMoreOnClick = () => {},
}: Props) => (
  <Carousel
    title={title}
    seeMoreText={seeMoreText}
    seeMoreHref={seeMoreHref}
    seeMoreOnClick={seeMoreOnClick}
    cardsPerSlide={4}
    className={classNames("w-full", className)}
    data-testid="article-related-articles"
  >
    {articles.map((article, slot) => (
      <ArticleCard
        author={article.author}
        data-testid="articles-carousel-article-card"
        href={article.link}
        imageProps={{ sizes: [250, null, null, 177, null, 250] }}
        imageUrl={article.featuredMedia.url}
        key={`article-card-${slot}`}
        onClick={() => articleCardOnClick(slot, article.title)}
        title={article.title}
      />
    ))}
  </Carousel>
);

export default ArticlesCarousel;
